import * as React from 'react';
import { LucideIcon } from 'lucide-react';
import {
  seoTaskPriorityClassName,
  type SeoTaskPriority,
} from 'features/DigitalMarketing/constants/seo';
import { DMDiv, DMText } from '../../../components/Primitives';

interface OptimizationTaskProps {
  title: string;
  description: string;
  priority: SeoTaskPriority;
  icon: LucideIcon;
  iconClassName: string;
  iconBgClassName: string;
}

export const OptimizationTask = ({
  title,
  description,
  priority,
  icon: Icon,
  iconClassName,
  iconBgClassName,
}: OptimizationTaskProps) => (
  <DMDiv
    as="li"
    className="flex h-[7.6vh] items-center justify-between gap-[2vh] border-b border-gray-100 px-[3vh] py-[1vh] last:border-b-0"
  >
    <DMDiv className="flex min-w-0 items-center gap-[2vh]">
      <DMText
        as="span"
        className={`flex h-[4.65vh] w-[4.65vh] shrink-0 items-center justify-center rounded-full ${iconBgClassName}`}
        aria-hidden="true"
      >
        <Icon
          className={`h-[2.32vh] w-[2.32vh] ${iconClassName}`}
          strokeWidth={2.4}
        />
      </DMText>
      <DMDiv className="min-w-0">
        <DMText
          as="h3"
          className="text-[2.08vh] font-bold leading-tight text-gray-950"
        >
          {title}
        </DMText>
        <DMText className="mt-[0.4vh] text-[1.52vh] font-medium leading-tight text-gray-500">
          {description}
        </DMText>
      </DMDiv>
    </DMDiv>
    <DMText
      as="span"
      className={`shrink-0 rounded-full px-[1.85vh] py-[0.78vh] text-[1.48vh] font-medium leading-none ${seoTaskPriorityClassName[priority]}`}
    >
      {priority}
    </DMText>
  </DMDiv>
);
